import { useTickets } from 'contexts/TicketsContext';
import { NoopT } from 'declarations/types/common';
import usePushNotifications from 'hooks/common/usePushNotifications';

type UseTicketsPageT = {
  handleSelectTicket: (ticketId: string) => NoopT;
};

const useTicketsPage = (): UseTicketsPageT => {
  /**
   * Hooks
   */
  const { setTicketId } = useTickets();
  usePushNotifications();

  /**
   * Handlers
   */
  const handleSelectTicket = (ticketId: string) => () => {
    setTicketId(ticketId);
  };

  return {
    handleSelectTicket,
  };
};

export default useTicketsPage;
